import { useState } from 'react';

export function usePagination(initialPage = 0, initialRowsPerPage = 10) {
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const handleChangePage = (newPage: number) => setPage(newPage);
  const handleChangeRowsPerPage = (newRows: number) => {
    setRowsPerPage(newRows);
    setPage(0);
  };

  return { page, setPage: handleChangePage, rowsPerPage, setRowsPerPage: handleChangeRowsPerPage };
}
